import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ObservationListLevel, AdditionalObservationListViewModel } from '../models/create-inspection.model';
import { AppService } from '../../../app.service';
import { SelectionLists, CurrentSelection, Make, Model, Family, Customer } from '../../../entities';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '../../../translate';
import { NewInspectionService } from '../services/new-inspection.service';
import { LoadingService } from '../../../shared/services/loading.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';import { NewObservationListPropertyComponent } from './new-observation-list-property/new-observation-list-property.component';
import { SetupEquipmentService } from '../../setup-equipment/setup-equipment.service';
import { CustomerSelectItem } from '../../setup-equipment/setup-equipment.model';
import { GenericIdName } from '../../GET_NEW_UI/setup-implement/setup-implement.model';
import { DialogSetupAnswersComponent } from '../../GET_NEW_UI/create-safety-digital-form/Components/dialog-setup-answers/dialog-setup-answers.component';
import { SetupNumericalAdditionalobsWornLimitComponent } from './setup-numerical-additionalobs-worn-limit/setup-numerical-additionalobs-worn-limit.component';
@Component({
  selector: 'app-add-inspection-observation-lists',
  templateUrl: './add-inspection-observation-lists.component.html',
  styleUrls: ['./add-inspection-observation-lists.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class AddInspectionObservationListsComponent implements OnInit, OnDestroy {

  addObservationListAgainst:  ObservationListLevel =  ObservationListLevel.Customer;

  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  _currentSelection: CurrentSelection = new CurrentSelection();

  selectedCustomer: Customer;
  selectedMake: Make;
  selectedModel: Model;
  selectedFamily: Family;

  newObservationList: AdditionalObservationListViewModel;

  selected: boolean;

  customerLevelObservationList: AdditionalObservationListViewModel[];
  modelLevelObservationList: AdditionalObservationListViewModel[];
  familyLevelObservationList: AdditionalObservationListViewModel[];
  translateSubscription: Subscription;
  customerList:CustomerSelectItem[]=[];

  QuestionTypes:GenericIdName[];

  userLanguage = 'english';
  constructor(
    private _appService: AppService,
    private _translate: TranslateService,
    private ref: ChangeDetectorRef,
    private _inspectionService: NewInspectionService,
    private _loading: LoadingService,
    private _dialog: MatDialog,
    private _equipmentService: SetupEquipmentService,
        ) { }

  ngOnInit() {
    this._appService.setPageTitle('Manage Additional Observation Lists');
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));

    this._equipmentService.getCustomerList().subscribe(result => { this.customerList = result;  }, error => { console.error(error); }, () => {  });
    this._equipmentService.getQuestionTypes().subscribe(result => { this.QuestionTypes = result;  }, error => { console.error(error); }, () => {  });


    
    //this._appService.getCustomerListForSelection(1, 10000).subscribe(result => { this._dropDownLists.customerList = result; this._dropDownListsFiltered.customerList = result;  }, error => { console.error(error); }, () => {  });
    this._appService.getFamilyListForSelection(1, 10000).subscribe(result => { this._dropDownLists.familyList = this._dropDownListsFiltered.familyList = result; }, error => { console.error(error); }, () => {  });
    this._appService.getMakeListForSelection(1, 10000).subscribe(result => { this._dropDownLists.makeList = this._dropDownListsFiltered.makeList = result; }, error => { console.error(error); }, () => {  });
    this._appService.getModelListForSelection(1, 10000).subscribe(result => {
        console.log(result);
        this._dropDownLists.modelList = result;
        this._dropDownListsFiltered.modelList = result;
      }, error => { console.error(error); }, () => {}
    );
  }



    ngOnDestroy() {
        this.translateSubscription.unsubscribe();
    }


    makeChanged(event) {
      this.addObservationListAgainst = ObservationListLevel.Model;
      this.selectedMake = event.value;
      if (!this.selectedMake) {
        return;
      }
      this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(
        m => m.MakeId === this.selectedMake.Id
      );

    }
    selectedAgainstCustomer(event) {
      this.addObservationListAgainst = ObservationListLevel.Customer;
      this.selectedCustomer = event.value;
      if (!this.selectedCustomer) {
        return;
      }
      this.selected = true;
      this.loadCustomerAddtionalObservationList();
    }
    selectedAgainstFamily(event) {
      this.addObservationListAgainst = ObservationListLevel.Family;
      this.selectedFamily = event.value;
      if (!this.selectedFamily) {
        return;
      }
      this.selected = true;
      this.loadFamilyAddtionalObservationList();
    }
    selectedAgainstModel(event) {
      this.selectedModel = event.value;
      if (!this.selectedModel) {
        return;
      }
      this.selected = true;
      this.loadModelAddtionalObservationList();
    }

    private loadModelAddtionalObservationList() {
      this._loading.startLoading();
      this._inspectionService.getModelLevelAdditionalObservationList(this.selectedModel.Id).subscribe(r => {
        this._loading.finishedLoading();
        this.modelLevelObservationList = r;
      });
    }
    private loadFamilyAddtionalObservationList() {
      this._loading.startLoading();
      this._inspectionService.getFamilyLevelAdditionalObservationList(this.selectedFamily.Id).subscribe(r => {
        this._loading.finishedLoading();
        this.familyLevelObservationList = r;
      });
    }
    private loadCustomerAddtionalObservationList() {
      this._loading.startLoading();
      this._inspectionService.getCustomerLevelAdditionalObservationList(this.selectedCustomer.Id).subscribe(r => {
        this.customerLevelObservationList = r;
        this._loading.finishedLoading();
      });
    }

    updateUserLang(lang: string) {
        this.userLanguage = lang;
        this.ref.detectChanges();
    }

    Translate(value: string): string {
        return this._translate.translateToLang(value, this.userLanguage);
    }


    selectAgainstIsVaild( ) {
      switch (this.addObservationListAgainst) {
        case  ObservationListLevel.Customer:
          return this.selectedAgainstCustomer === undefined || this.selectedAgainstCustomer === null;
        case  ObservationListLevel.Model:
          return this.selectedAgainstModel === undefined || this.selectedAgainstModel === null;
        case  ObservationListLevel.Family:
          return this.selectedAgainstFamily === undefined || this.selectedAgainstFamily === null;
      }
      return true;
     }



     editObservation(model) {
      const dialogRef = this._dialog.open(NewObservationListPropertyComponent, {
        panelClass: 'removeModalOverflow',
        data: {
            model: model,
            QuestionTypes:this.QuestionTypes,
          createfromObsList:true,

        }
      });

      dialogRef.afterClosed().subscribe(edit => {
        if (edit) {
          switch (this.addObservationListAgainst) {
            case  ObservationListLevel.Customer:
            this.loadCustomerAddtionalObservationList();
              break;
            case  ObservationListLevel.Model:
            this.loadModelAddtionalObservationList();
              break;
            case  ObservationListLevel.Family:
            this.loadFamilyAddtionalObservationList();
              break;
          }
        }
      });

     }


     addNewObservationListOnCustomer() {

      const dialogRef = this._dialog.open(NewObservationListPropertyComponent, {
        panelClass: 'removeModalOverflow',
        data: {
          selectedCustomer: this.selectedCustomer,
          QuestionTypes:this.QuestionTypes,
          createfromObsList:true,

        }
      });

      dialogRef.afterClosed().subscribe(addedCustomer => {
        if (addedCustomer) {
          this.loadCustomerAddtionalObservationList();
        }
      });
     }
     addNewObservationListOnModel() {
      console.log('Model');
      const dialogRef = this._dialog.open(NewObservationListPropertyComponent, {
        panelClass: 'removeModalOverflow',
        data: {
          selectedModel: this.selectedModel,
          QuestionTypes:this.QuestionTypes,
          createfromObsList:true,



        }
      });

      dialogRef.afterClosed().subscribe(addedModel => {
        if (addedModel) {
          this.loadModelAddtionalObservationList();
        }
      });
     }
     addNewObservationListOnFamily() {
      console.log('Family');
      const dialogRef = this._dialog.open(NewObservationListPropertyComponent, {
        panelClass: 'removeModalOverflow',
        data: {
          selectedFamily: this.selectedFamily,
          QuestionTypes:this.QuestionTypes,
          createfromObsList:true,

        }
      });

      dialogRef.afterClosed().subscribe(addedFamily => {
        if (addedFamily) {
          this.loadFamilyAddtionalObservationList();
        }
      });
     }


     onClickEditAnswer(model){

   if(model.QuestionTypeId!=5){
    const dialogRef = this._dialog.open(DialogSetupAnswersComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
        QuestionTypes:this.QuestionTypes,
        FormId:0,
        QuestionId:model.Id,
        CatId:0,
        
        Title:model.Title,
        QuestionTypeId:model.QuestionTypeId,
        Description:"",
        isAdditonalObs:true,
      }

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        switch (this.addObservationListAgainst) {
          case  ObservationListLevel.Customer:
          this.loadCustomerAddtionalObservationList();
            break;
          case  ObservationListLevel.Model:
          this.loadModelAddtionalObservationList();
            break;
          case  ObservationListLevel.Family:
          this.loadFamilyAddtionalObservationList();
            break;
        }
      }
    });
   }else{
    const dialogRef = this._dialog.open(SetupNumericalAdditionalobsWornLimitComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
        Title:model.Title,
        QuestionTypeId:model.QuestionTypeId,
        NoofDecimal:model.NoOfDecimal,
        worn0Percent:model.Worn0percent,
        worn100Percent:model.Worn100percent,
        Id:model.Id,
      }

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        switch (this.addObservationListAgainst) {
          case  ObservationListLevel.Customer:
          this.loadCustomerAddtionalObservationList();
            break;
          case  ObservationListLevel.Model:
          this.loadModelAddtionalObservationList();
            break;
          case  ObservationListLevel.Family:
          this.loadFamilyAddtionalObservationList();
            break;
        }
      }
    });
   }

      
  
     
    }
  }
